import { ButtonProps } from '@vk-cloud-solutions/marketing-ui';

import { NextImageProps } from '~components/NextImage/NextImage.types';
import { SectionProps } from '~components/Section/Section.types';
import { ArticlePageBlockComponent } from '~types/BlockComponent.types';

export enum SectionSubscribeMods {
  Small = 'small',
}

export type SectionSubscribeProps = SectionProps & {
  component: ArticlePageBlockComponent.SectionSubscribe;
  title: string;
  titleMenu?: string;
  text: string;
  mailoutId: string;
  image?: NextImageProps;
  button?: ButtonProps;
  blockMods?: SectionSubscribeMods[];
  isHidden?: boolean;
};
